<template>
  <b-sidebar
    v-model="visible"
    title="Held sales — this store"
    right
    shadow
    width="400px"
    @hidden="$emit('close')"
  >
    <div v-if="!heldSales.length" class="p-3 text-muted small">
      No held transactions{{ canAuditOthers ? " for this store" : "" }}.
    </div>
    <div v-else class="held-list p-2">
      <p class="small text-muted px-1 mb-2">
        {{
          canAuditOthers
            ? "All cashiers on this floor. Recall any ticket to take payment."
            : "Your held tickets. Recall one to take payment."
        }}
      </p>
      <template v-if="mine.length">
        <div v-if="canAuditOthers" class="held-group-label">Yours</div>
        <div v-for="sale in mine" :key="sale.id" class="held-item">
          <button
            type="button"
            class="held-item__recall"
            @click="$emit('recall', sale)"
          >
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <strong class="held-item__tip">{{
                  sale.holdLabel || "No tip"
                }}</strong>
                <span class="held-item__number small text-muted d-block">
                  {{ sale.saleNumber }}
                </span>
              </div>
              <span class="held-item__total">{{ formatMoney(sale.total) }}</span>
            </div>
            <div class="small text-muted mt-1">
              {{ sale.itemCount }} items
              <span v-if="sale.heldAt"> · {{ formatHeldAge(sale.heldAt) }}</span>
            </div>
          </button>
          <button
            type="button"
            class="held-item__print"
            title="Print held receipt"
            @click="$emit('print', sale)"
          >
            Print
          </button>
        </div>
      </template>
      <template v-if="canAuditOthers && others.length">
        <div class="held-group-label">Other cashiers</div>
        <div
          v-for="sale in others"
          :key="sale.id"
          class="held-item held-item--other"
        >
          <button
            type="button"
            class="held-item__recall"
            @click="$emit('recall', sale)"
          >
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <strong class="held-item__tip">{{
                  sale.holdLabel || "No tip"
                }}</strong>
                <span class="held-item__number small text-muted d-block">
                  {{ sale.saleNumber }}
                </span>
              </div>
              <span class="held-item__total">{{ formatMoney(sale.total) }}</span>
            </div>
            <div class="small text-muted mt-1">
              {{ sale.userName || "Cashier" }} · {{ sale.itemCount }} items
              <span v-if="sale.heldAt"> · {{ formatHeldAge(sale.heldAt) }}</span>
            </div>
          </button>
          <button
            type="button"
            class="held-item__print"
            title="Print held receipt"
            @click="$emit('print', sale)"
          >
            Print
          </button>
        </div>
      </template>
    </div>
    <template #footer="{ hide }">
      <div class="p-2 border-top">
        <b-button block variant="outline-secondary" @click="hide">Close</b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
export default {
  name: "HeldSalesPanel",
  props: {
    value: { type: Boolean, default: false },
    heldSales: { type: Array, default: () => [] },
    currentUserId: { type: String, default: "" },
    canAuditOthers: { type: Boolean, default: false },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    mine() {
      if (!this.currentUserId) return this.heldSales;
      return this.heldSales.filter((s) => s.userId === this.currentUserId);
    },
    others() {
      if (!this.canAuditOthers || !this.currentUserId) return [];
      return this.heldSales.filter((s) => s.userId !== this.currentUserId);
    },
  },
  methods: {
    formatHeldAge(iso) {
      if (!iso) return "";
      const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
      if (mins < 1) return "just now";
      if (mins < 60) return `${mins}m ago`;
      const hrs = Math.floor(mins / 60);
      return `${hrs}h ago`;
    },
  },
};
</script>

<style scoped>
.held-group-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  padding: 0.35rem 0.25rem 0.4rem;
}
.held-item {
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.held-item:hover {
  border-color: var(--akkurate-green, #018673);
}
.held-item--other {
  background: #fffbeb;
  border-color: #f5d889;
}
.held-item__recall {
  flex: 1;
  min-width: 0;
  padding: 0.75rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.held-item__print {
  flex: 0 0 auto;
  align-self: stretch;
  border: 0;
  border-left: 1px solid var(--surface-border, #e5e7eb);
  background: transparent;
  color: var(--akkurate-green, #018673);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0 0.75rem;
  cursor: pointer;
}
.held-item__print:hover {
  background: #f0fdf4;
}
</style>
